import { render, staticRenderFns } from "./AssetSensitivity.vue?vue&type=template&id=2f2b057b&scoped=true"
import script from "./AssetSensitivity.vue?vue&type=script&lang=js"
export * from "./AssetSensitivity.vue?vue&type=script&lang=js"
import style0 from "./AssetSensitivity.vue?vue&type=style&index=0&id=2f2b057b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b057b",
  null
  
)

export default component.exports